<template>
  <div class="content">
    <div class="content_title">
      Соглашение
    </div>
    <div class="content_row">
      <div>Договор:<br />{{ documentName }}</div>
      <div>Поселок:<br />{{ villageName }}</div>
      <div>Инициатор:<br />{{ initiator }}</div>
    </div>
    <div class="content_row">
      <div>Баланс: {{ balance }}</div>
      <router-link
        :to="'/backoffice/documents/agreements/' + id + '/payment'"
        tag="button"
      >
        Пополнить
      </router-link>
    </div>
    <div class="content_title">
      Услуги в соглашении
    </div>
    <div class="content_row" v-for="(service, key) in services" :key="key">
      <div>
        {{ service.NAME }}
      </div>
      <div>
        {{ service.DESCRIPTION }}
      </div>
    </div>
    <div class="content_title">
      Ежемесячные начисления
    </div>
    <div class="content_row" v-for="(rule, key) in accrualrules" :key="key">
      <div>
        {{ rule.SERVICE }}
      </div>
      <div>
        {{ rule.SUM }}
      </div>
    </div>
    <div class="content_title" v-show="writeoffs">
      Списания
    </div>
    <div class="content_row col-4" v-for="(offs, key) in writeoffs" :key="key">
      <div>
        {{ offs.DATE }}
      </div>
      <div>
        {{ offs.SUM }}
      </div>
      <div>
        {{ offs.BASE_WRITE_OFFS }}
      </div>
    </div>
    <div class="form-row-line">
      <div class="form-field">
        <button @click="applyAgreement" v-show="!agreementApply">
          Подписать
        </button>
        <button class="cancel" v-show="agreementApply">
          Подписан
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "GetAgreement",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      url: config.backend_url,
      services: [],
      accrualrules: [],
      writeoffs: [],
      agreementApply: true,
      initiator: "",
      villageName: "",
      balance: "",
      documentName: ""
    };
  },
  computed: {},
  watch: {},
  methods: {
    applyAgreement: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "agreements/apply/",
          filter: { ID: self.id },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.agreementApply = data;
          }
        });
    },
    getAgreement: function(id) {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "agreements/get-all-data/",
          filter: { ID: id },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            console.log(data);
            let user = data.USERS[data.DOCUMENT.USER];
            self.services = data.SERVICES;
            self.accrualrules = data.ACCRUALRULES;
            self.initiator = user.FIO + " " + user.PHONE;
            self.villageName = data.VILLAGE.NAME;
            self.documentName = data.DOCUMENT.NAME;
            self.agreementApply = data.AGREEMENT.EDS;
            self.balance = data.AGREEMENT.BALANCE;
            self.writeoffs = data.WRITEOFFS;
          }
        });
    }
  },
  created() {
    this.getAgreement(this.id);
  }
};
</script>
